import React from "react"
import { Helmet } from "react-helmet"
import Menu from "./menu"

export default function Header({ className }) {
  return(
    <div className={`header ${className}`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Illustration Research Symposium</title>
        <meta name="description" content="11th Illustration Research Symposium, 11-12 February 2021, Kingston University, London UK" />
        <html lang="en" />
      </Helmet>
      <Menu />
    </div>
  )
}
